import { FormOption } from 'src/common-types';

export const PAGE_SIZE_OPTIONS = [ 10, 25, 50, 100 ];
export const DEFAULT_PAGE_SIZE = PAGE_SIZE_OPTIONS[ 1 ];
export const TOAST_INFO_DURATION_IN_SECONDS = 6;
export const INFRA_CO_IDS = [ 1, 2, 3, 4 ];
export const DATE_FORMAT_DAY = /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/[1-9][0-9][0-9]{2}$/;
export const DATE_FORMAT_MONTH = /^(0[1-9]|1[0-2])\/[1-9][0-9][0-9]{2}$/;
export const DATE_FORMAT_YEAR = /^[1-9][0-9][0-9]{2}$/;

export const yesNoOptions: FormOption[] = [
  {
    value: true,
    label: 'Yes',
    isDictionary: false,
    isDictionaryActiveValue: false,
  },
  {
    value: false,
    label: 'No',
    isDictionary: false,
    isDictionaryActiveValue: false,
  },
];